import { gql } from "@apollo/client";

export const UPDATE_USER = gql`
  mutation UpdateUser($input: UserUpdates) {
    updateUser(input: $input) {
      _id
      checkForInvites
      createdAt
      currency
      timezone
      description
      displayName
      email
      expoPushTokens
      firebaseId
      gender
      header
      hometown
      instagramHandle
      isCreator
      isOpenProfile
      language
      mapStyle
      measurementSystem
      temperatureUnit
      name
      pageName
      photo
      picture
      referralCode
      showOnboarding
      username
      website
      invited
      organisationRole
      organisation {
        _id
        name
        logo
        theme {
          main1
          main2
          main3
          main4
        }
      }
    }
  }
`;

